export default {
    namespaced: true,
    state: {
        filter: {
            name: null,
            type: null,
            airDate: null,
            expiryDate: null,
        }
    },
    getters: {
        filter(state) {
            return state.filter
        }
    },
    mutations: {
        SET_FILTER(state, filter) {
            for (let key in filter) {
                state.filter[key] = filter[key]
            }
        }
    },
    actions: {
        setFilter({commit, state}, filter) {
            commit('SET_FILTER', filter)
        },
        resetFilter({commit}) {
            commit('SET_FILTER', {
                name: null,
                type: null,
                airDate: null,
                expiryDate: null,
            })
        },
        async getList({commit, state}) {
            const response = await axios.get('/admin/api/promotions', {
                params: state.filter
            })

            let navItems = []
            for (let i = 0; i < response?.data?.length; i++) {
                navItems.push({
                    id: response.data[i]?.id,
                    title: response.data[i]?.title_en,
                    category: response.data[i]?.tenant?.name,
                    subCategory: [
                        response.data[i]?.air_date,
                        response.data[i]?.expiration_date,
                    ],
                    attribute: null,
                    url: '/admin/promotions/' + response.data[i]?.id,
                })
            }

            // set data to store sideNav
            commit('sideNav/SET_ITEMS', navItems, {root: true})
        }
    }
}
